import LReducer from "./layout";
import SPopupReducer from "./slidingPopup";

export const layoutReducer = LReducer;
export const slidingPopupReducer = SPopupReducer;
